interface Props {
    tag: string
    className?: string
}

const DiscountTag = ({ tag, className = '' }: Props) => {
    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[9px] sm:text-[10px] font-black bg-[#E8F0E8] text-[#2D3E2D] border border-[#5C7A5C]/20 shadow-2xs truncate ${className}`}>
            {tag}
        </span>
    )
}

export default DiscountTag

